<template>
  <aside
    :class="[
      'navbar navbar-vertical navbar-expand-lg navbar-dark',
      isProduction ? '' : 'navbar-staging'
    ]"
    style="overflow-x: hidden"
  >
    <div class="container">
      <button
        class="navbar-toggler"
        :class="navbar.collapsed ? 'collapsed' : ''"
        type="button"
        :aria-expanded="navbar.collapsed"
        @click="_navbar()"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <router-link to="/dashboard" class="navbar-brand navbar-brand-autodark">
        <img
          :src="asset('nav-white-logo.png')"
          alt=""
          class="navbar-brand-image"
        />
      </router-link>

      <!-- SEARH MENU -->
      <div class="find-menu" @click="_search">
        <i class="fe fe-search"></i>
      </div>

      <transition name="fade">
        <div
          class="form-find-menu"
          v-show="isSearch"
          @click="
            $event.target.classList.contains('form-find-menu')
              ? (isSearch = false)
              : true
          "
        >
          <div
            class="text-white"
            style="
              position: absolute;
              left: 50%;
              transform: translate(-50%, 20px);
            "
            v-if="keyword.length > 1 && filter.length > 0"
          >
            Tekan tab untuk fokus ke hasil pencarian
          </div>

          <div class="input-center" :class="keyword.length > 1 ? 'filled' : ''">
            <div class="input-icon">
              <span class="input-icon-addon">
                <i class="fe fe-search"></i>
              </span>
              <input
                type="text"
                class="form-control form-control-rounded"
                :class="keyword.length > 0 ? 'filled' : ''"
                ref="search"
                placeholder="Ketik nama menu"
                v-model="keyword"
                autofocus
              />
            </div>

            <div class="result" v-if="keyword.length > 1">
              <li class="list-link" v-for="(li, i) in filter" :key="i">
                <router-link :to="li.link">
                  <i class="fe fe-external-link mr-1 text-primary"></i>
                  {{ li.text }}
                </router-link>
              </li>
            </div>
          </div>
        </div>
      </transition>

      <!-- /SEARH MENU -->

      <span v-if="!isProduction" class="badge bg-orange-lt blink">STAGING MODE</span>

      <div
        class="collapse navbar-collapse"
        :class="navbar.collapsed ? 'show' : ''"
        style="transition: 0.5s"
      >
        <ul class="navbar-nav pt-lg-3">
          <li
            v-for="(item, i) in menus"
            :key="i"
            class="nav-item"
            :class="
              item.submenu != null
                ? 'dropdown'
                : $route.path.split('/').pop() == item.group
                ? 'active'
                : ''
            "
          >
            <div class="text-muted mt-2" v-if="item.sparate">
              <span class="small" style="padding: 0 13px"> LAINNYA </span>
              <div style="border-top: 1px rgba(0, 0, 0, 0.3) solid" />
            </div>

            <router-link
              class="nav-link"
              :to="item.link != null ? item.link : ''"
              :class="item.submenu != null ? 'drop down-toggle' : ''"
              @click.native="item.link == null ? _collapsed(item) : null"
            >
              <span class="nav-link-title" style="width: 100%">
                <i
                  class="fe fe-chevron-right float-right mt-1 d-toggle"
                  :class="item.text == collapsed ? 'collapsed' : ''"
                  v-if="item.submenu != null"
                ></i>
                <i class="la la-lg mr-2" :class="item.icon"></i>
                {{ item.text }}
              </span>
            </router-link>

            <ul
              class="dropdown-menu"
              :class="
                item.text == collapsed ||
                (item.text == collapsed &&
                  $route.path.split('/').indexOf(item.group) > -1)
                  ? navbar.show
                  : ''
              "
              v-if="item.submenu != null"
            >
              <li
                v-for="(child, l) in item.submenu"
                :key="l"
                :class="
                  $route.path.split('/').pop() == child.active ? 'active' : ''
                "
              >
                <router-link
                  class="dropdown-item"
                  :to="child.link"
                  v-html="child.text"
                />
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              target="_blank"
              href="https://tawk.to/chat/666118d2981b6c5647791e26/1hvlkhu5t"
            >
              <span class="nav-link-title" style="width: 100%">
                <i class="la la-lg mr-2 fa-comment"></i>
                IT Support
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </aside>
</template>

<script>
import helper from "@/assets/js/helper.js";

export default {
  name: "Sidebar",
  components: {},
  mixins: [helper],
  data() {
    return {
      navbar: {
        collapsed: false,
        show: "show-7",
      },

      collapsed: null,
      keyword: "",
      isSearch: false,
      filter: [],

      menus: [
        {
          icon: "la-stream",
          text: "Dashboard",
          link: "/dashboard",
          group: "dashboard",
          permission: "*",
        },
        {
          icon: "fa-database",
          text: "Master",
          group: "master",
          permission: "group menu master",
          submenu: [
            {
              text: "Perusahaan",
              link: "/dashboard/master/perusahaan",
              active: "perusahaan",
              permission: "menu perusahaan",
            },
            {
              text: "Depo",
              link: "/dashboard/master/depo",
              active: "depo",
              permission: "menu depo",
            },
            {
              text: "Principal",
              link: "/dashboard/master/principal",
              active: "principal",
              permission: "menu principal",
            },
            {
              text: "Brand",
              link: "/dashboard/master/brand",
              active: "brand",
              permission: "menu brand",
            },
            {
              text: "Segmen",
              link: "/dashboard/master/segmen",
              active: "segmen",
              permission: "menu segmen",
            },
            {
              text: "Barang",
              link: "/dashboard/master/barang",
              active: "barang",
              permission: "menu barang",
            },
            {
              text: "Tim",
              link: "/dashboard/master/tim",
              active: "tim",
              permission: "menu tim",
            },
            {
              text: "Tipe Harga",
              link: "/dashboard/master/tipe-harga",
              active: "tipe-harga",
              permission: "menu tipe harga",
            },
            {
              text: "Salesman",
              link: "/dashboard/master/salesman",
              active: "salesman",
              permission: "menu salesman",
            },
            {
              text: "Salesman Canvass",
              link: "/dashboard/master/canvas",
              active: "canvas",
              permission: "menu canvass",
            },
            {
              text: "Mitra",
              link: "/dashboard/master/mitra",
              active: "mitra",
              permission: "menu mitra",
            },
          ],
        },
        {
          icon: "fa-desktop",
          text: "Monitoring",
          group: "monitoring",
          permission: "menu group monitoring",
          submenu: [
            {
              text: "Monitoring Salesman",
              link: "/dashboard/monitoring/salesman",
              active: "salesman",
              permission: "menu monitoring pareto",
            },
            {
              text: "Monitoring Pareto",
              link: "/dashboard/monitoring/pareto",
              active: "pareto",
              permission: "menu monitoring pareto",
            },
            {
              text: "Monitoring Retur",
              link: "/dashboard/monitoring/retur",
              active: "retur",
              permission: "menu monitoring retur",
            },
            {
              text: "Monitoring Ota",
              link: "/dashboard/monitoring/ota",
              active: "ota",
              permission: "menu monitoring ota",
            },
            {
              text: "Monitoring Pro",
              link: "/dashboard/monitoring/pro",
              active: "pro",
              permission: "menu monitoring pro",
            },
            {
              text: "Monitoring Stock Tmp",
              link: "/dashboard/monitoring/stock-tmp",
              active: "stock-tmp",
              permission: "menu monitoring stock tmp",
            },
            {
              text: "Monitoring Service Level",
              link: "/dashboard/monitoring/service-level",
              active: "service-level",
              permission: "menu service level monitoring",
            },
            {
              text: "Monitoring Outlet Condition",
              link: "/dashboard/monitoring/outlet-condition",
              active: "outlet-condition",
              permission: "menu monitoring outlet condition",
            },
            {
              text: "Quick Searching",
              link: "/dashboard/monitoring/quick-search",
              active: "quick-search",
              permission: "menu quick search",
            },
          ],
        },
        {
          icon: "la-tags",
          text: "Sales",
          group: "sales",
          permission: "menu group sales",
          submenu: [
            {
              text: "Toko",
              link: "/dashboard/sales/toko",
              active: "toko",
              permission: "menu toko",
            },
            {
              text: "Verify Toko",
              link: "/dashboard/sales/toko/unverified",
              active: "toko-unverified",
              permission: "verifikasi toko",
            },
            {
              text: "Update Toko",
              link: "/dashboard/sales/toko/update",
              active: "toko-update",
              permission: "update batch toko",
            },
            {
              text: "Limit Kredit",
              link: "/dashboard/sales/limit-kredit",
              active: "limit-kredit",
              permission: "*",
            },
            {
              text: "Promo",
              link: "/dashboard/sales/promo",
              active: "promo",
              permission: "menu promo",
            },
            {
              text: "Penjualan",
              link: "/dashboard/sales/penjualan",
              active: "penjualan",
              permission: "menu penjualan",
            },
            {
              text: "Delivery Penjualan",
              link: "/dashboard/sales/delivery-penjualan",
              active: "delivery-penjualan",
              permission: "tanggal terima penjualan",
            },
            {
              text: "Retur Penjualan",
              link: "/dashboard/sales/retur-penjualan",
              active: "retur-penjualan",
              permission: "menu retur penjualan",
            },
            {
              text: "Retur Penjualan Group",
              link: "/dashboard/sales/retur-penjualan/ungroup",
              active: "retur-penjualan-group",
              permission: "menu retur penjualan",
            },
            {
              text: "Sharing Promo",
              link: "/dashboard/sales/sharing-promo",
              active: "sharing-promo",
              permission: "menu sharing promo",
            },
            {
              text: "Posisi Penjualan",
              link: "/dashboard/sales/posisi-penjualan",
              active: "posisi-penjualan",
              permission: "posisi penjualan",
            },
            {
              text: "Realisasi Program",
              link: "/dashboard/sales/realisasi-program",
              active: "realisasi-program",
              permission: "menu realisasi program",
            },
            {
              text: "Rekapitulasi DO",
              link: "/dashboard/sales/rekapitulasi-do",
              active: "rekapitulasi-do",
              permission: "menu rekapitulasi do",
            },
            {
              text: "Target Salesman",
              link: "/dashboard/sales/target-salesman",
              active: "target-salesman",
              permission: "menu target salesman",
            },
            {
              text: "Export Data Penjualan",
              link: "/dashboard/sales/export-data-penjualan",
              active: "export-data-penjualan",
              permission: "menu laporan export penjualan",
            },
              {
              text: "Kuota Sales",
              link: "/dashboard/sales/kuota-sales",
              active: "kuota-sales",
              permission: "menu stock barang",
            },
          ],
        },
        {
          icon: "fa-area-chart",
          text: "Reports",
          group: "reports",
          permission: "menu group laporan",
          submenu: [
            {
              text: "Laporan Aktual",
              link: "/dashboard/reports/laporan-aktual",
              active: "laporan-aktual",
              permission: "menu laporan aktual",
            },
            {
              text: "Laporan Gross Profit",
              link: "/dashboard/reports/laporan-gross-profit",
              active: "gross-profit",
              permission: "menu gross profit",
            },
            {
              text: "Laporan Sales To Trade",
              link: "/dashboard/reports/laporan-sales-to-trade",
              active: "laporan-sales-to-trade",
              permission: "menu laporan stt",
            },
            {
              text: "Laporan Sales",
              link: "/dashboard/reports/laporan-sales",
              active: "laporan-sales",
              permission: "menu laporan total sales",
            },
            {
              text: "Laporan Sales Daily",
              link: "/dashboard/reports/laporan-sales-daily",
              active: "laporan-sales-daily",
              permission: "menu laporan total sales",
            },
            {
              text: "Laporan Sales Distributor",
              link: "/dashboard/reports/laporan-sales-distributor",
              active: "laporan-sales-distributor",
              permission: "menu laporan total sales",
            },
            {
              text: "Laporan Salses To Trade Pajak",
              link: "/dashboard/reports/laporan-stt-pajak",
              active: "laporan-stt-pajak",
              permission: "menu laporan stt",
            },
            {
              text: "Laporan Sales To Distributor",
              link: "/dashboard/reports/laporan-sales-to-distributor",
              active: "laporan-sales-to-distributor",
              permission: "menu laporan std",
            },
            {
              text: "Laporan SLA Sales",
              link: "/dashboard/reports/laporan-sla-sales",
              active: "laporan-sla-sales",
              permission: "menu laporan sla sales",
            },
            {
              text: "Laporan Penjualan Harian",
              link: "/dashboard/reports/laporan-penjualan-harian",
              active: "laporan-penjualan-harian",
              permission: "menu laporan penjualan harian",
            },
            {
              text: "Laporan Jurnal Penjualan",
              link: "/dashboard/reports/laporan-jurnal-penjualan",
              active: "laporan-jurnal-penjualan",
              permission: "laporan jurnal penjualan",
            },
            {
              text: "Laporan Retur Penjualan",
              link: "/dashboard/reports/laporan-retur-penjualan",
              active: "laporan-retur-penjualan",
              permission: "menu laporan retur penjualan",
            },
            {
              text: "Laporan Total Retur",
              link: "/dashboard/reports/laporan-total-retur",
              active: "laporan-total-retur",
              permission: "menu laporan total retur",
            },
            {
              text: "Laporan Total Retur Daily",
              link: "/dashboard/reports/laporan-total-retur-daily",
              active: "laporan-total-retur-daily",
              permission: "menu laporan total retur",
            },
            {
              text: "Laporan Total Retur Distributor",
              link: "/dashboard/reports/laporan-total-retur-distributor",
              active: "laporan-total-retur-distributor",
              permission: "menu laporan total retur",
            },
            {
              text: "Laporan Retur Segmen",
              link: "/dashboard/reports/laporan-retur-segmen",
              active: "laporan-retur-segmen",
              permission: "menu laporan retur segmen",
            },
            {
              text: "Laporan Rangking Toko",
              link: "/dashboard/reports/laporan-omset-toko",
              active: "laporan-omset-toko",
              permission: "menu laporan omset toko",
            },
            {
              text: "Laporan Ranking Barang",
              link: "/dashboard/reports/laporan-ranking-barang",
              active: "laporan-ranking-barang",
              permission: "menu laporan ranking barang",
            },
            {
              text: "Laporan Kunjungan Salesman",
              link: "/dashboard/reports/laporan-salesman/kunjungan",
              active: "kunjungan",
              permission: "menu kunjungan sales",
            },
            {
              text: "Laporan Pembagian Promo",
              link: "/dashboard/reports/pembagian-promo",
              active: "pembagian-promo",
              permission: "menu laporan pembagian promo",
            },
            {
              text: "Laporan Monitoring Stock",
              link: "/dashboard/reports/laporan-monitoring-stock",
              active: "laporan-monitoring-stock",
              permission: "menu laporan monitoring stock",
            },
            {
              text: "Laporan Suggest Order",
              link: "/dashboard/reports/laporan-suggest-order",
              active: "laporan-suggest-order",
              permission: "menu laporan suggest order",
            },
            {
              text: "Laporan Mutasi Barang",
              link: "/dashboard/reports/laporan-mutasi-barang",
              active: "laporan-mutasi-barang",
              permission: "menu laporan mutasi barang",
            },
            {
              text: "Laporan Distribution History",
              link: "/dashboard/reports/laporan-distribution-history",
              active: "laporan-distribution-history",
              permission: "menu laporan distribution history",
            },
            {
              text: "Tracking Outlet Active",
              link: "/dashboard/reports/tracking-outlet-active",
              active: "tracking-ao",
              permission: "*",
            },
            {
              text: "Tracking Effective Call",
              link: "/dashboard/reports/laporan-ec",
              active: "laporan-ec",
              permission: "menu laporan ec",
            },
            {
              text: "Tracking Sales Target",
              link: "/dashboard/reports/tracking-sales-target",
              active: "tracking-sales-target",
              permission: "menu laporan tracking sales target",
            },
            {   
              text: "Tracking Retur Sales",
              link: "/dashboard/reports/laporan-retur-sales",
              active: "laporan-retur-sales",
              permission: "menu tracking sales retur",
            },
            {
              text: "Service Level Sales MT",
              link: "/dashboard/reports/service-level/sales-mt",
              active: "service-level-sales-mt",
              permission: "menu service level sales mt",
            },
            {
              text: "Tracking Service Level Sales",
              link: "/dashboard/reports/tracking-service-level-sales",
              active: "tracking-service-level-sales",
              permission: "tracking service level sales",
            },
            {
              text: "Laporan Kunjungan Salesman",
              link: "/dashboard/reports/kunjungan-salesman",
              active: "laporan-kunjungan-salesman",
              permission: "*",
            },
          ],
        },
        {
          icon: "la-handshake",
          text: "Mitra",
          group: "mitra",
          permission: "menu group mitra",
          submenu: [
            {
              text: "Penjualan",
              link: "/dashboard/mitra/penjualan",
              active: "penjualan",
              permission: "*",
            },
            {
              text: "Retur Penjualan",
              link: "/dashboard/mitra/retur-penjualan",
              active: "retur-penjualan",
              permission: "*",
            },
            {
              text: "Pelunasan Piutang",
              link: "/dashboard/mitra/pelunasan",
              active: "pelunasan",
              permission: "*",
            },
            {
              text: "Rekapitulasi Penagihan",
              link: "/dashboard/mitra/rekapitulasi-penagihan",
              active: "rekapitulasi-penagihan",
              permission: "*",
            },
            {
              text: "Laporan Posisi Stock",
              link: "/dashboard/mitra/laporan-posisi-stock",
              active: "laporan-posisi-stock",
              permission: "menu posisi stock gudang mitra",
            },
            // {
            //   text: "Posisi Stock Gudang",
            //   link: "/dashboard/mitra/posisi-stock-gudang-mitra",
            //   active: "posisi-stock-gudang-mitra",
            //   permission: "menu posisi stock gudang mitra",
            // },
            {
              text: "Laporan Aktual",
              link: "/dashboard/mitra/laporan-aktual",
              active: "laporan-aktual",
              permission: "*",
            },
            {
              text: "Laporan Piutang",
              link: "/dashboard/mitra/data-piutang",
              active: "data-piutang",
              permission: "*",
            },
            {
              text: "Laporan Sales To Trade",
              link: "/dashboard/mitra/laporan-sales-to-trade",
              active: "laporan-sales-to-trade",
              permission: "*",
            },
            {
              text: "Laporan Retur Penjualan",
              link: "/dashboard/mitra/laporan-retur-penjualan",
              active: "laporan-retur-penjualan",
              permission: "*",
            },
            {
              text: "Laporan Penjualan Harian",
              link: "/dashboard/mitra/laporan-penjualan-harian",
              active: "laporan-penjualan-harian",
              permission: "*",
            },
            {
              text: "Konversi Pajak Coretax",
              link: "/dashboard/mitra/konversi-pajak-coretax",
              active: "mitra-konversi-pajak-coretax",
              permission: "*",
            },
          ],
        },
        {
          icon: "la-money-bill",
          text: "Purchase",
          group: "purchase",
          permission: "menu group purchase",
          submenu: [
            {
              text: "Pembelian",
              link: "/dashboard/purchase/data-pembelian",
              active: "data-pembelian",
              permission: "menu faktur pembelian",
            },
            {
              text: "Pelunasan",
              link: "/dashboard/purchase/pelunasan-pembelian",
              active: "pelunasan-pembelian",
              permission: "menu pelunasan pembelian",
            },
          ],
        },
        {
          icon: "la-wallet",
          text: "Finance",
          group: "finance",
          permission: "menu group finance",
          submenu: [
            {
              text: "Invoice Note",
              link: "/dashboard/finance/invoice-note",
              active: "invoice-note",
              permission: "menu invoice note",
            },
            {
              text: "Data Piutang",
              link: "/dashboard/finance/data-piutang",
              active: "data-piutang",
              permission: "menu pelunasan penjualan",
            },
            {
              text: "Pelunasan Piutang",
              link: "/dashboard/finance/pelunasan",
              active: "pelunasan",
              permission: "menu pelunasan penjualan",
            },
            {
              text: "Pelunasan Piutang Canvass",
              link: "/dashboard/finance/pelunasan-canvass",
              active: "pelunasan-canvass",
              permission: "menu pelunasan penjualan canvass",
            },
            {
              text: "Pelunasan Piutang Driver",
              link: "/dashboard/finance/pelunasan-driver",
              active: "pelunasan-driver",
              permission: "menu pelunasan penjualan driver",
            },
            {
              text: "Rekapitulasi Penagihan",
              link: "/dashboard/finance/rekapitulasi-penagihan",
              active: "rekapitulasi-penagihan",
              permission: "menu rekapitulasi penagihan",
            },
            {
              text: "Laporan Ranking Piutang",
              link: "/dashboard/finance/laporan-ranking-piutang",
              active: "ranking-piutang",
              permission: "menu laporan ranking piutang",
            },
            {
              text: "Laporan Klaim Retur",
              link: "/dashboard/finance/klaim-retur",
              active: "klaim-retur",
              permission: "laporan klaim retur",
            },
            {
              text: "Surat Konfirmasi Piutang",
              link: "/dashboard/finance/surat-tagihan",
              active: "surat-tagihan",
              permission: "menu surat tagihan",
            },
          ],
        },

        {
          icon: "la-archive",
          text: "Inventory",
          group: "inventory",
          permission: "*",
          submenu: [
            {
              text: "Gudang",
              link: "/dashboard/inventory/gudang",
              active: "gudang",
              permission: "menu gudang",
            },
            {
              text: "Stock Gudang",
              link: "/dashboard/inventory/stock",
              active: "stock",
              permission: "menu stock barang",
            },
            {
              text: "Stock Opname",
              link: "/dashboard/inventory/stock-opname",
              active: "stock-opname",
              permission: "menu stock opname",
            },
            {
              text: "Penerimaan Barang",
              link: "/dashboard/inventory/penerimaan-barang",
              active: "penerimaan-barang",
              permission: "menu penerimaan barang",
            },
            {
              text: "Distribution Plan",
              link: "/dashboard/inventory/distribution-plan/service-level",
              active: "distribution-plan",
              permission: "menu distribusi plan",
            },
            {
              text: "Delivery Report",
              link: "/dashboard/inventory/distribution-plan/delivery-report",
              active: "delivery-report",
              permission: "menu delivery report",
            },
            {
              text: "Realisasi DO",
              link: "/dashboard/inventory/realisasi-do/",
              active: "realisasi-do",
              permission: "menu realisasi do",
            },
            // {
            //   text: "Delivery Order",
            //   link: "/dashboard/inventory/delivery-order",
            //   active: "delivery-order",
            //   permission: "*",
            // },
            {
              text: "Mutasi Barang",
              link: "/dashboard/inventory/mutasi-barang",
              active: "mutasi-barang",
              permission: "menu mutasi barang",
            },
            {
              text: "Riwayat Barang",
              link: "/dashboard/inventory/riwayat-barang",
              active: "riwayat-barang",
              permission: "menu riwayat barang",
            },
            {
              text: "Adjusment Barang",
              link: "/dashboard/inventory/adjustment-barang",
              active: "adjustment-barang",
              permission: "menu adjustment barang",
            },
            // {
            //   text: "Posisi Stock Gudang",
            //   link: "/dashboard/inventory/posisi-stock-gudang",
            //   active: "posisi-stock-gudang",
            //   permission: "menu posisi stock gudang",
            // },
            {
              text: "Laporan Posisi Stock",
              link: "/dashboard/inventory/laporan-posisi-stock",
              active: "laporan-posisi-stock",
              permission: "menu laporan posisi stock",
            },
            {
              text: "Laporan Adjusment Barang",
              link: "/dashboard/inventory/laporan-adjustment-barang",
              active: "laporan-adjustment-barang",
              permission: "menu laporan adjustment",
            },
            {
              text: "Rekapitulasi DO Driver",
              link: "/dashboard/inventory/rekapitulasi-do",
              active: "rakapitulasi-do-driver",
              permission: "menu rekapitulasi do",
            },
            {
              text: "Laporan Pelunasan Driver",
              link: "/dashboard/inventory/laporan-pelunasan-driver",
              active: "laporan-pelunasan-driver",
              permission: "menu pelunasan driver",
            },
          ],
        },

        {
          icon: "la-address-card",
          text: "Administrator",
          group: "administrator",
          permission: "menu group administrator",
          submenu: [
            {
              text: "User",
              link: "/dashboard/administrator/users",
              active: "users",
              permission: "menu user",
            },
            {
              text: "Driver",
              link: "/dashboard/administrator/driver",
              active: "driver",
              permission: "menu driver",
            },
            {
              text: "Kendaraan",
              link: "/dashboard/administrator/kendaraan",
              active: "kendaraan",
              permission: "menu kendaraan",
            },
            {
              text: "Role User",
              link: "/dashboard/administrator/role",
              active: "role",
              permission: "menu role",
            },
            {
              text: "Role Permissions",
              link: "/dashboard/administrator/permissions",
              active: "permissions",
              permission: "menu permission",
            },
            {
              text: "Permissions Principal",
              link: "/dashboard/administrator/akses-principal",
              active: "akses-principal",
              permission: "menu akses principal",
            },
            {
              text: "Hari Efektif",
              link: "/dashboard/administrator/hari-efektif",
              active: "hari-efektif",
              permission: "import hari efektif",
            },
            {
              text: "Reference",
              link: "/dashboard/administrator/reference",
              active: "reference",
              permission: "menu reference",
            },
            {
              text: "Select Option",
              link: "/dashboard/administrator/option",
              active: "reference",
              permission: "menu option",
            },
            {
              text: "Whitelist Outlet",
              link: "/dashboard/administrator/whitelist-outlet",
              active: "whitelist-outlet",
              permission: "menu toko tanpa limit",
            },
            {
              text: "Api Request History",
              link: "/dashboard/administrator/api-request-history",
              active: "api-request-history",
              permission: "*",
            },
            {
              text: "Vendor",
              link: "/dashboard/administrator/vendor",
              active: "vendor",
              permission: "menu vendor",
            },
          ],
        },

        {
          icon: "la-terminal",
          text: "External App",
          group: "external",
          permission: "menu group external app",
          submenu: [
            // {
            //   text: "Survey Harga",
            //   link: "/dashboard/external/survey-harga",
            //   active: "survey-harga",
            //   permission: "menu survey harga",
            // },
            // {
            //   text: "Group Toko",
            //   link: "/dashboard/administrator/group-toko",
            //   active: "group-toko",
            //   permission: "*",
            // },
            {
              text: "ESPT",
              link: "/dashboard/external/espt",
              active: "espt",
              permission: "*",
            },
            {
              text: "Briging",
              link: "/dashboard/external/bridging",
              active: "bridging",
              permission: "*",
            },
            {
              text: "Briging Kino",
              link: "/dashboard/external/kino-bridging",
              active: "kino-bridging",
              permission: "menu kino bridging",
            },
            {
              text: "Export Kino",
              link: "/dashboard/external/export-kino",
              active: "export-kino",
              permission: "*",
            },
            {
              text: "Konversi Pajak",
              link: "/dashboard/external/konversi-pajak",
              active: "konversi-pajak",
              permission: "*",
            },
            {
              text: "Konversi Pajak Coretax",
              link: "/dashboard/external/konversi-pajak-coretax",
              active: "konversi-pajak-coretax",
              permission: "menu konversi pajak coretax",
            },
            {
              text: "Import Nomor Pajak",
              link: "/dashboard/external/import-nomor-pajak",
              active: "import-nomor-pajak",
              permission: "*",
            },
            {
              text: "Import Nomor Pajak Rekap",
              link: "/dashboard/external/rekap-import-pajak",
              active: "rekap-import-pajak",
              permission: "*",
            },
            {
              text: "Import Order SAN",
              link: "/dashboard/external/import-order-san",
              active: "import-order-san",
              permission: "*",
            },
            {
              text: "Import Order Sosro",
              link: "/dashboard/external/import-order-sosro",
              active: "import-order-sosro",
              permission: "import order sosro",
            },
            {
              text: "Import Order Kino",
              link: "/dashboard/external/import-order-kino",
              active: "import-order-kino",
              permission: "*",
            },
            {
              text: "Mapping MARS",
              link: "/dashboard/external/mapping-mars",
              active: "mapping-mars",
              permission: "export mars",
            },
            {
              text: "Export MARS",
              link: "/dashboard/external/export-mars",
              active: "export-mars",
              permission: "export mars",
            },
            {
              text: "Bidging Mapping Data",
              link: "/dashboard/external/bridging-mapping-data",
              active: "bridging-mapping-data",
              permission: "*",
            },
            {
              text: "Dua Kelinci Import",
              link: "/dashboard/external/dk-import",
              active: "dk-import",
              permission: "*",
            },
            {
              text: "Dua Kelinci Report",
              link: "/dashboard/external/dk-report",
              active: "dk-report",
              permission: "*",
            },
            {
              text: "Report Stock V2",
              link: "/dashboard/external/report-stock-v2",
              active: "report-stock-v2",
              permission: "*",
            },
            {
              text: "STT Enhanced",
              link: "/dashboard/external/stt-enhanced",
              active: "stt-enhanced",
              permission: "menu stt enhanced",
            },
            {
              text: "Export Mars Enhanced",
              link: "/dashboard/external/export-mars-enhanced",
              active: "export-mars-enhanced",
              permission: "export mars enhanced",
            },
          ],
        },

        {
          icon: "fa-history",
          text: "Testing",
          group: "testing",
          permission: "menu group testing",
          submenu: [
            {
              text: "Test Dashboard",
              link: "/dashboard/testing/dashboard",
              active: "test-dashboard",
              permission: "*",
            },
            {
              text: "Test Posisi Stock",
              link: "/dashboard/testing/posisi-stock",
              active: "test-posisi-stock",
              permission: "*",
            },
            {
              text: "Test Faktur Pajak Search",
              link: "/dashboard/testing/faktur-pajak-search",
              active: "test-faktur-pajak-search",
              permission: "*",
            },
            {
              text: "Test Laporan Sales to Trade",
              link: "/dashboard/testing/laporan-sales-to-trade",
              active: "test-stt",
              permission: "*",
            },
          ],
        },

        {
          icon: "la-gear",
          text: "Pengaturan",
          link: "#",
          group: "setting",
          sparate: true,
        },
      ],

      keydown: [],
    };
  },

  methods: {
    _collapsed(item) {
      if (item.submenu != null) {
        this.collapsed = this.collapsed == item.text ? null : item.text;
      }

      this.navbar.show =
        item.submenu == null ? "" : "show-" + item.submenu.length;
    },

    _navbar() {
      this.navbar.collapsed = !this.navbar.collapsed;
    },

    _setSideBar(path) {
      let group = path.split("/")[2],
        menus = this.menus;
      for (let i = 0; i < menus.length; i++) {
        if (menus[i].group == group) {
          this._collapsed(menus[i]);
        }
      }
    },

    _search() {
      this.isSearch = true;
      this.keyword = "";

      setTimeout(() => {
        this.$refs.search.focus();
      }, 200);
    },
  },

  mounted() {
    this._setSideBar(this.$route.path);

    let newMenus = [];

    // check permissions
    let permissions = JSON.parse(localStorage.permissions),
      menus = this.menus;
    let permissTLC = permissions.map((x) => x.toLowerCase());

    for (let i = 0; i < menus.length; i++) {
      if (menus[i].permission != "*") {
        if (permissTLC.indexOf(menus[i].permission) > -1) {
          newMenus.push(menus[i]);
        }
      } else {
        newMenus.push(menus[i]);
      }
    }

    for (let i = 0; i < newMenus.length; i++) {
      let submenus = newMenus[i].submenu,
        newSubmenus = [];

      if (submenus != null) {
        for (let l = 0; l < submenus.length; l++) {
          if (submenus[l].permission != null) {
            if (
              permissTLC.indexOf(submenus[l].permission) > -1 ||
              submenus[l].permission == "*"
            ) {
              // console.log(submenus[l].permission)
              newSubmenus.push(submenus[l]);
            }
          }
        }

        // console.log(newMenus[i])
        newMenus[i].submenu = newSubmenus;
        newSubmenus = [];
      }
    }

    this.menus = newMenus;

    // hapus parent menu yang tidak memiliki submenu
    for (let i = 0; i < newMenus.length; i++) {
      let submenus = newMenus[i].submenu;

      if (submenus != null) {
        if (submenus.length == 0) {
          this.menus.splice(i, 1);
        }
      }
    }

    // ctrl + f
    document.addEventListener("keydown", (e) => {
      let keys = [91, 70];

      if (keys.indexOf(e.keyCode) > -1) {
        this.keydown.push(e.keyCode);
      }

      if (this.keydown.length == 2) {
        e.preventDefault();
        this._search();
      }
    });

    document.addEventListener("keyup", (e) => {
      this.keydown = [];
    });
  },

  created() {},

  computed: {
    isProduction() {
      return process.env.VUE_APP_ENV === 'production';
    },
  },

  watch: {
    $route(to, from) {
      this.collapsed = null;
      this._setSideBar(to.path);
      this.isSearch = false;
    },

    keyword: function (key) {
      this.filter = [];

      let menus = [];

      for (let i = 0; i < this.menus.length; i++) {
        let submenu = this.menus[i].submenu;

        if (submenu != null) {
          for (let l = 0; l < submenu.length; l++) {
            menus.push(submenu[l]);
          }
        }
      }

      for (let i = 0; i < menus.length; i++) {
        if (
          menus[i].text.toString().toLowerCase().includes(key.toLowerCase())
        ) {
          this.filter.push(menus[i]);
        }
      }
    },
  },
};
</script>

<style src="./sidebar.scss" lang="scss" scoped />
